<script>
import createEmailTemplateItem from './../automation-archive/create-email-template-item'
import modalGatedFeatures from '../modals/modal-non-premium-integration-screen.vue'
import { MODAL_NAMES, PREMIUM_FEATURES_KEYS } from '../../utils/constants'

export default {
  name: "templatelist",
  components: {
    createEmailTemplateItem,
    modalGatedFeatures
  },
  async mounted() {
    let self = this;

    await this.pullTemplates();

    this.$root.$on("duplicate::template::confirmed", async function () {
      await self.$A.TemplateService.Duplicate(self.duplicateThis);
      self.duplicateThis = null;
      await self.pullTemplates();
    });

    this.$root.$on("delete::template::confirmed", async function () {
      await self.$A.TemplateService.Delete(self.deleteThis);
      self.deleteThis = null;
      await self.pullTemplates();
    });

    this.$root.$on("template_item:canceled", function () {
      self.editThis = null;
    });

    this.$root.$on("email::template::saved", async function () {
      await self.pullTemplates();
    })
  },
  methods: {
    editTemplate: function (template) {
      this.editThis = template;
      this.$root.$emit("edit::template::email");
    },
    pullTemplates: async function () {
      this.templates = await this.$A.TemplateService.GetAll();
    },
    onRowClicked(item) {
      this.editTemplate(item);
      this.$root.$emit('bv::toggle::collapse', 'create-template-sidebar-right');
    },
    hasRowMenu(item) {
      const canDuplicate = this.isPaidAccount;
      const canDelete = item.name !== 'Automatic Reminder';
      return canDuplicate || canDelete;
    },
    createEmailTemplate: function () {
      if (!this.isPaidAccount) {
        this.$bvModal.show(MODAL_NAMES.GATED_FEATURES_MODAL);
        return;
      }
      this.editThis = null;
      this.$root.$emit("create::template::email");
    }
  },
  computed: {
    sortedTemplates: function () {
      function compare(a, b) {
        if (a.name < b.name)
          return -1;
        if (a.name > b.name)
          return 1;
        return 0;
      }

      return this.templates.sort(compare);
    },
    canCreateTemplate() {
      return this.isPaidAccount;
    }
  },
  data() {
    return {
      templates: [],
      duplicateThis: null,
      deleteThis: null,
      editThis: null,
      fields: [
        {
          key: 'emailinfo',
          sortable: false,
          label: ""
        },
        {
          key: 'edit',
          sortable: false,
          label: "",
          tdClass: "action-cell"
        },
        {
          key: 'menu',
          sortable: false,
          label: "",
          tdClass: "action-cell action-cell-menu"
        },
      ],
      PREMIUM_FEATURES_KEYS,
      MODAL_NAMES
    };
  },
  props: {
    isPaidAccount: {
      type: Boolean,
      required: true
    }
  },
};
</script>

<template>
  <div style="background-color: #eef2f5!important"
       class="on-mobile text-dark d-flex justify-content-center flex-md-wrap pb-5 px-3 px-md-0">
    <b-card class="mt-3 p-0 h-75 account-template-card">
      <b-card-body>
        <div class="card-toolbar">
          <div class="toolbar-count">
            {{ sortedTemplates.length }} {{ sortedTemplates.length === 1 ? 'template' : 'templates' }}
          </div>
          <div v-if="canCreateTemplate">
            <a class="button button-light button-green templates-btn mb-0" v-b-toggle.create-template-sidebar-right
               @click=createEmailTemplate()>Create Email Template</a>
          </div>
          <div v-else>
            <button class="button button-locked-email feature-lock-btn" @click="createEmailTemplate">
              Create Email Template <img src="/img/automation-feature-lock.svg" class="feature-icon"/>
            </button>
          </div>
        </div>
        <!-- Template Table -->
        <b-table
            class="template-table mb-0"
            :items="sortedTemplates"
            :fields="fields"
            responsive
            hover
            thead-class="d-none"
            tbody-tr-class="template-row"
            @row-clicked="onRowClicked"
        >
          <template #head()="data">
            <span class="table-header-text">{{ data.label }}</span>
          </template>
          <template #cell(emailinfo)="data">
            <div class="row-cols-9">
              <span class="column-header-text">{{ data.item.name }}</span>
            </div>
          </template>
          <template #cell(edit)="data">
            <button
                class="row-edit-btn"
                v-b-toggle.create-template-sidebar-right
                @click.stop="editTemplate(data.item)"
            >
              Edit
            </button>
          </template>
          <template #cell(menu)="data">
            <span @click.stop>
            <b-dropdown
                v-if="hasRowMenu(data.item)"
                variant="link"
                toggle-class="row-menu-toggle"
                menu-class="row-menu"
                no-caret
                right
                no-flip
                boundary="viewport"
                offset="4"
            >
              <template #button-content>
                <b-icon-three-dots-vertical />
                <span class="sr-only">More actions</span>
              </template>
              <b-dropdown-item
                  v-if="isPaidAccount"
                  data-cy="duplicateEmailTemplate"
                  v-b-modal.duplicateTemplateModal
                  @click="duplicateThis = data.item.id"
              >
                Duplicate
              </b-dropdown-item>
              <b-dropdown-item
                  v-if="data.item.name !== 'Automatic Reminder'"
                  data-cy="deleteEmailTemplate"
                  v-b-modal.deleteTemplateModal
                  @click="deleteThis = data.item.id"
              >
                Delete
              </b-dropdown-item>
            </b-dropdown>
            </span>
          </template>
        </b-table>
        <!-- Modals -->
        <modal
            name="deleteTemplateModal"
            eventToEmitOnConfirmation="delete::template::confirmed"
            question="Delete This Template?"
            body="Are you sure you want to delete this template? You cannot undo this action."
            confirm-button-text="Yes, Delete"
        />
        <modal
            name="duplicateTemplateModal"
            eventToEmitOnConfirmation="duplicate::template::confirmed"
            question="Duplicate This Template?"
            ref="duplicateTemplate"
            confirm-button-text="Yes, Duplicate"
            body="Create a copy of this template."
        />
        <createEmailTemplateItem @saved="pullTemplates" :template-to-edit="{...editThis}"/>
        <modalGatedFeatures :feature-key="PREMIUM_FEATURES_KEYS.EMAIL_TEMPLATE" :modalId="MODAL_NAMES.GATED_FEATURES_MODAL" />
      </b-card-body>
    </b-card>
  </div>
</template>

<style scoped>

/deep/ .table th, .table td {
  vertical-align: none;
}

.field-item h3 {
  font-size: 18px;
}

.template-button img {
  height: 15px;
  margin-left: 10px;
}

.account-template-card {
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.account-template-card ::v-deep .card-body {
  padding: 0px;
}

.card-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-bottom: 1px solid #E5E7EB;
}

.toolbar-count {
  font-family: 'Open Sans';
  font-size: 13px;
  color: #6B7280;
}

::v-deep .template-table table {
  margin-bottom: 0;
}

::v-deep .template-table table td {
  padding: 14px 24px !important;
  vertical-align: middle !important;
  border-top: 1px solid #F1F2F4;
  border-bottom: 0;
}

::v-deep .template-table table td.action-cell {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

::v-deep .template-table table td.action-cell-menu {
  padding-left: 0 !important;
  padding-right: 16px !important;
}

::v-deep .template-table tbody tr:first-child td {
  border-top: 0;
}

::v-deep .template-table table td.action-cell {
  width: 1%;
  white-space: nowrap;
  text-align: right;
}

::v-deep .row-menu-toggle {
  color: #6B7280;
  padding: 4px 6px;
  border-radius: 4px;
}

::v-deep .row-menu-toggle:hover,
::v-deep .row-menu-toggle:focus {
  color: #1B1B1C;
  background-color: #F1F2F4;
  text-decoration: none;
  box-shadow: none;
}

::v-deep .row-menu {
  min-width: 8rem;
  font-size: 14px;
}

.table-header-text {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.05em;
}

.column-header-text {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1B1B1C;
}

::v-deep .template-row {
  cursor: pointer;
}

::v-deep .template-table.table-hover tbody tr:hover,
::v-deep .template-table tbody tr:hover {
  background-color: #F9FAFB;
  color: inherit;
}

.row-edit-btn {
  background: transparent;
  border: 1px solid #D1D5DB;
  color: #1B1B1C;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 16px;
  border-radius: 6px;
  line-height: 20px;
}

.row-edit-btn:hover {
  background: #FFFFFF;
  border-color: #B4B9C0;
}

.row-edit-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(107, 114, 128, 0.2);
}

.templates-btn {
  padding: 9px 17px !important;
  font-weight: normal;
  height: 38px;
  background: #019256;
  box-shadow: 0px 1px 2px rgba(8, 11, 13, 0.05);
  border-radius: 6px;
}

@media (max-width: 576px) {
  .card-toolbar {
    padding: 12px 16px;
  }

  .templates-btn {
    padding: 8px !important;
    border-radius: 5px;
    font-weight: normal !important;
  }
}

.button-locked-email {
  background: var(--Red-600, #CC333F);
  border-radius: 6px;
  box-shadow: 0px 1px 2px 0px rgba(8, 11, 13, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #ffffff;
  font-weight: normal;
  height: 38px;
}

.feature-icon {
  margin-bottom: 2px;
  margin-left: 4px;
  height: 22px;
}

.feature-lock-btn {
  width: fit-content;
  padding: 9px 17px !important;
  white-space: nowrap;
}

</style>
